// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3sHGF","cardFooterItem":"Footer_cardFooterItem__vxr0M"};